import React, { useState, useEffect } from 'react';
import { ArrowRight, Award, Users, Wrench } from 'lucide-react';

export const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const slides = [
    {
      image: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/87g5nks6_WhatsApp%20Image%202025-11-29%20at%2020.57.20.jpeg',
      alt: 'Balazs Dach & Abbruch Service - Projekt 1'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/uc1wjo6f_WhatsApp%20Image%202025-11-29%20at%2020.57.21.jpeg',
      alt: 'Balazs Dach & Abbruch Service - Projekt 2'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/uwggoafx_WhatsApp%20Image%202025-11-29%20at%2020.57.22%20%281%29.jpeg',
      alt: 'Balazs Dach & Abbruch Service - Projekt 3'
    }
  ];

  const stats = [
    { icon: Award, value: '15+', label: 'Jahre Erfahrung' },
    { icon: Users, value: '500+', label: 'Zufriedene Kunden' },
    { icon: Wrench, value: '1000+', label: 'Projekte abgeschlossen' }
  ];

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 px-4 md:px-0">
      {/* Background Slider with Zoom Effect - Contained */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.alt}
              className={`w-full h-full object-cover ${
                index === currentSlide ? 'animate-zoom' : ''
              }`}
              style={{ filter: 'brightness(1.1)' }}
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/75 via-gray-900/65 to-gray-900/50"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          {/* Badge - More Space from Top */}
          <div className="inline-flex items-center space-x-2 bg-yellow-500/20 border border-yellow-500/50 px-3 md:px-4 py-2 rounded-full mb-6 backdrop-blur-sm mt-8 md:mt-16">
            <Award className="w-4 h-4 text-yellow-400" />
            <span className="text-yellow-200 font-semibold text-xs md:text-sm">Ihr zuverlässiger Partner in Bochum</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Professionelle
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-red-500 mt-2">
              Dach- & Abbrucharbeiten
            </span>
          </h1>

          <p className="text-lg md:text-2xl text-gray-300 mb-8 leading-relaxed">
            Von Dachdecker über Zimmerer bis Abbruch – Ihr Experte für alle Gewerke rund ums Gebäude.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <button
              onClick={scrollToContact}
              className="group flex items-center justify-center space-x-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 hover:scale-105 shadow-2xl"
            >
              <span>Kostenlos beraten lassen</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            <button
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              className="flex items-center justify-center space-x-2 bg-gray-900/50 hover:bg-gray-900 border-2 border-yellow-500 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 backdrop-blur-sm"
            >
              <span>Unsere Leistungen</span>
            </button>
          </div>

          {/* Stats - More Space and Better Positioning */}
          <div className="grid grid-cols-3 gap-3 md:gap-6 mb-12">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div
                  key={index}
                  className="bg-gray-800/40 backdrop-blur-sm border border-gray-700 p-3 md:p-4 rounded-lg hover:bg-gray-800/60 transition-all duration-300 hover:scale-105"
                >
                  <Icon className="w-6 h-6 md:w-8 md:h-8 text-yellow-400 mb-2" />
                  <div className="text-xl md:text-3xl font-bold text-white mb-1">{stat.value}</div>
                  <div className="text-xs md:text-sm text-gray-400">{stat.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

    </section>
  );
};